import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { ROLE_TASK_MANAGER } from '../../../../redux/constants/rolesConstants';
import {
  commentLimitValidation,
  hourValidation,
  notBlankValidation,
  priceValidation,
} from '../../../../utils/validations';
import Input from '../../../shared/input/Input';
import Price from '../../../shared/price/Price';
import TaskSelect from '../../../shared/select/task/TaskSelect';
import FormToggle from '../../../shared/toggle/FormToggle';
import Toggle from '../../../shared/toggle/Toggle';

const VisitTaskForm = ({ onSubmit, task, readOnly, loading }) => {
  const methods = useForm({ defaultValues: task });
  const hours = methods.watch('hours') || 0;
  const rate = methods.watch('rate') || 0;
  const [isCreateNew, setIsCreateNew] = useState(false);
  const canCreateTask = useSelector((state) => state.auth?.userData?.roles.includes(ROLE_TASK_MANAGER));

  const toggleMode = () => {
    if (isCreateNew) {
      methods.setValue('taskName', '');
      methods.clearErrors('taskName');
      methods.setValue('task', task?.task || null);
    } else {
      methods.setValue('task', null);
      methods.clearErrors('task');
    }
    setIsCreateNew(!isCreateNew);
  };

  return (
    <FormProvider {...methods}>
      <form
        id="visitTask-form"
        noValidate
        className="modal-form"
        onSubmit={methods.handleSubmit((data) => onSubmit(data))}
      >
        <div className="flex items-start gap-3">
          <div className="flex-1">
            {isCreateNew ? (
              <Input
                label="Назва нової послуги"
                name="taskName"
                disabled={readOnly || loading}
                placeholder={'Введіть назву послуги'}
                validation={notBlankValidation}
                autoFocus
              />
            ) : (
              <TaskSelect disabled={loading || readOnly} autoFocus="true" />
            )}
          </div>
          {!readOnly && canCreateTask && (
            <div className="mt-6 md:mt-9">
              <Toggle isActive={isCreateNew} disabled={loading} onChange={toggleMode} label="Нова" />
            </div>
          )}
        </div>
        <Input
          label="Кількість нормо-годин"
          type="number"
          name="hours"
          disabled={readOnly || loading}
          placeholder={'Введіть кількість нормо-години'}
          validation={hourValidation}
        />
        <Input
          label="Ціна нормо-години"
          type="number"
          name="rate"
          disabled={readOnly || loading}
          placeholder={'Введіть ціну нормо-години'}
          validation={priceValidation}
        />
        <Input
          label="Коментар"
          multiline
          name="comment"
          disabled={readOnly || loading}
          placeholder={'Введіть коментар'}
          validation={commentLimitValidation}
        />
        <FormToggle name="isCritical" label="Критична послуга" disabled={readOnly || loading} />
        <Price price={hours * rate} />
      </form>
    </FormProvider>
  );
};

export default VisitTaskForm;
